<template lang="pug">
  v-row(no-gutters style="padding-bottom:100px; padding-top: 12px;").v-layout1
    v-col(cols=12)
      head-member
    v-col(cols=12 class="gametap").px-4
      external-game-tab
</template>
<script>     
import { banners as apiBanner } from '@/apis'  
import { ROUTE_DEPOSIT, ROUTE_WITHDRAW } from '@/const/route'
import dialogAlert from '@/components/Dialog/DialogIndexAlert.vue'  
import dialogRoulete from '@/components/Dialog/DialogRoulete'
import HeadMember from "@/components/AppBar/HeadMember";
import ExternalGameTab from './child/ExternalGameTab'
export default {  
  components : {
    dialogAlert,
    dialogRoulete,
    ExternalGameTab,
    HeadMember,
  },

  data: () => ({
    bannerUrl : [],
    innerWidth: window.innerWidth
  }), 
  computed : { 
    ROUTE_DEPOSIT: () => ROUTE_DEPOSIT,
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    isMobile () {
      return this.innerWidth < 640
    }
  },   

  async mounted () {     
    await this.getBanner ();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    // this.$nextTick(()=>this.$refs.dialogroulete.open())
  },   
  
  methods: {  
    imageIcon (id) {
      try{
        return require(`@/assets/index/v2/${id}.svg`)} 
      catch {
        return require(`@/assets/anything/image-placeholder.svg`)
      } 
    },
    async getBanner () { 
      const [err,data,] =  await apiBanner.get({ type_id: 1 })
      
      if(err) {
        return
      }
      this.bannerUrl = data 
    }, 

    goToWithdraw () {
      this.GA('Withdraw','')
      this.$router.push({
        name: ROUTE_WITHDRAW
      })
    },

    goToDeposit () {
      this.GA('Deposit','')
      this.$router.push({
        name: ROUTE_DEPOSIT
      })
    },

    GA (action,name){
      this.$ga.event('Button', action, 'IndexPage-V2', name)
    },
    onResize () {
      this.innerWidth = window.innerWidth
    },
  }
}
</script>
<style scoped>
.v-layout1 {
  background-color: var(--v3-sec-color-20);
  display: flex;
  min-height: 100dvh;
  flex-direction: column;
  gap: 30px;
}

@media only screen and (max-width: 640px) {
  .v-layout1 {
    padding-left: 0;
    padding-right: 0;
  }
}

.banner {
  order: 1 !important;
}
.userinfotap {
  order: 2 !important;
}
.gametap {
  order: 3 !important;
}
</style>